/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

import { MenuItem, ColorOptions, TypeOptions } from '../../menus/types';

@Component({
  selector: 'bulb-menu-list-demos',
  templateUrl: './menu-list-demos.component.html',
  styleUrls: ['./menu-list-demos.component.scss'],
  standalone: false,
})
export class MenuListDemosComponent {
  constructor(private messageService: MessageService) { }

  showToast(detail: string = 'The menu item was clicked!', severity: string = 'success') {
    this.messageService.add({
      key: 'menuListDemo',
      severity,
      summary: 'Menu List Demo',
      detail,
    });
  }

  public menuItems: MenuItem[] = [
    {
      label: 'Basic Menu',
      icon: 'plus',
      command: () => this.showToast(),
    },
    {
      label: 'No Functionality',
      icon: 'download',
      command: () => { },
    },
    {
      label: 'Just The Basics',
      icon: 'redo',
      command: () => this.showToast('Just the basics.'),
    },
    {
      label: 'Danger',
      icon: 'exclamation-triangle',
      command: () => this.showToast('Just the basics.'),
      color: ColorOptions.ALERT,
    },
  ];

  public menuItemsDisabledOption = [
    ...this.menuItems,
    {
      label: 'Disabled Example',
      icon: 'download',
      disabled: true,
      command: () => this.showToast('This toast should not be seen.', 'error'),
    },
  ];

  public menuItemsLinkedOption = [
    {
      label: 'Click To Go To Webpage',
      icon: 'download',
      disabled: false,
      type: TypeOptions.LINK,
      link: 'https://help.bulbapp.com/',
    },
  ];

  public menuItemsDescription = [
    ...this.menuItems,
    {
      label: 'Item + Description',
      icon: 'redo',
      descriptiveText: 'This is a longer description with more words taking up more space.',
      command: () => this.showToast(),
    },
  ];

  public menuItemsToggle = [
    ...this.menuItems,
    {
      label: 'Toggle It',
      icon: 'redo',
      type: TypeOptions.TOGGLE,
      model: false,
      command: () => {
        const thisModel = this.menuItemsToggle[this.menuItemsToggle.length - 1].model;
        this.menuItemsToggle[this.menuItemsToggle.length - 1].model = !thisModel;
        this.showToast();
      },
    },
  ];

  public customFooterContent = 'This is a custom footer, it has no functionality and only provides information.';
}
